
    <ng-template #dataSource let-source>
      <div class="btn-group mr-1 ml-1">
        <button
          class="btn"
          type="button"
          [ngClass]="{
            'btn-success': selectedFeed && selectedFeed.key == source.key,
            'btn-info': !(selectedFeed && selectedFeed.key == source.key)
          }"
          (click)="select($event, source.key)"
        >
          {{ source.name }}
        </button>
        <button
          class="btn"
          type="button"
          [ngClass]="{
            'btn-success': selectedFeed && selectedFeed.key == source.key,
            'btn-info': !(selectedFeed && selectedFeed.key == source.key)
          }"
          (click)="remove($event, source.key)"
        >
          <i class="fa fa-minus-circle"></i>
        </button>
      </div>
    </ng-template>

    <ng-template #graphSource let-source>
      <div class="btn-group mr-2 mb-2">
        <button
          class="btn"
          type="button"
          [ngClass]="{
            'btn-success': selected[source.key],
            'btn-info': !selected[source.key]
          }"
          (click)="toggleGraph($event, source.key)"
        >
          {{ source.name }}
        </button>
        <button
          class="btn btn-primary"
          (click)="fetchAndRefresh($event, source.key)"
        >
          <i class="fa fa-plus-circle"></i>
        </button>
      </div>
    </ng-template>

    <ng-container [ngSwitch]="layout">
      <!-- ===================================== -->
      <!-- Default (Card)                        -->
      <!-- ===================================== -->
      <ng-container *ngSwitchDefault>
        <div class="extended-device-chart-logical-widget card">
          <div class="card-header">Feed</div>
          <div class="card-body">
            <div class="d-flex flex-wrap align-items-center mb-4">
              <div class="mr-2 mb-2" style="min-width: 130px;">
                <select
                  class="form-control"
                  name="aggregate"
                  [(ngModel)]="time_period"
                >
                  <option
                    *ngFor="let entry of time_options"
                    value="{{ entry.value }}"
                  >
                    {{ entry.text }}
                  </option>
                </select>
              </div>
              <div class="mr-2 mb-2" style="min-width: 170px;" *ngIf="entity">
                <select
                  class="form-control"
                  name="timezone"
                  [(ngModel)]="time_zone"
                >
                  <option
                    *ngFor="let entry of time_zone_options"
                    value="{{ entry.value }}"
                  >
                    {{ entry.text }}
                  </option>
                </select>
              </div>
              <div class="mr-2 mb-2" style="min-width: 170px;" *ngIf="entity">
                <select
                  class="form-control"
                  name="field"
                  [(ngModel)]="for_field"
                >
                  <option
                    *ngFor="let entry of field_options"
                    value="{{ entry.value }}"
                  >
                    {{ entry.text }}
                  </option>
                </select>
              </div>

              <div class="mr-2 mb-2 d-flex align-items-center bg-light border rounded px-2" style="height: 38px;">
                <label class="switch switch-3d switch-primary mb-0 mr-2">
                  <input
                    class="switch-input switch-primary"
                    [(ngModel)]="metric_units"
                    type="checkbox"
                  />
                  <span class="switch-slider"></span>
                </label>
                <span class="small font-weight-bold text-dark">
                  {{ metric_units ? 'Metric' : 'Imperial' }}
                </span>
              </div>

              <div class="mr-2 mb-2">
                <button
                  class="btn btn-primary d-inline-flex align-items-center"
                  style="height: 38px;"
                  (click)="addRange($event)"
                  title="Add Feed"
                >
                  <i class="fa fa-plus-circle mr-1"></i> Add Feed
                </button>
              </div>

              <div class="mb-2">
                <button
                  class="btn btn-outline-success d-inline-flex align-items-center"
                  style="height: 38px;"
                  (click)="customRange($event, chartModal)"
                  title="Pick Date Range"
                >
                  <i class="fa fa-calendar mr-1"></i> Date Range
                </button>
              </div>
            </div>

            <div class="row" *ngIf="entity">
              <tabset #view class="col">
                <tab heading="Table View">
                  <div class="row" *ngIf="entity">
                    <div class="col">
                      <ng-container
                        *ngFor="let source of objectValues(entity.feeds)"
                      >
                        <ng-container
                          *ngTemplateOutlet="
                            dataSource;
                            context: { $implicit: source }
                          "
                        ></ng-container>
                      </ng-container>
                    </div>
                  </div>

                  <ng-container *ngIf="selectedFeed">
                    <div class="row mt-4">
                      <div class="col">
                        <h1>
                          {{ selectedFeed.name }} ({{ selectedFeed.units }})
                        </h1>
                      </div>
                    </div>

                    <div
                      *ngIf="selectedFeed.variant_entries"
                      class="row mt-4 border-bottom bg-dark text-white"
                    >
                      <div class="col-3">Date</div>
                      <div class="col">Variant</div>
                      <div class="col">Spot</div>
                      <div class="col">Average</div>
                      <div class="col">High</div>
                      <div class="col">Low</div>
                      <div class="col">Tally</div>
                    </div>
                    <div
                      *ngIf="!selectedFeed.variant_entries"
                      class="row mt-4 border-bottom bg-dark text-white"
                    >
                      <div class="col-3">Date</div>
                      <div class="col">Spot</div>
                      <div class="col">Average</div>
                      <div class="col">High</div>
                      <div class="col">Low</div>
                      <div class="col">Tally</div>
                    </div>

                    <div class="row">
                      <div class="col text-center">
                        <new-spinner
                          *ngIf="selectedFeed.fetching"
                          [size]="'sm'"
                        ></new-spinner>
                        <div class="btn-group" *ngIf="!selectedFeed.fetching">
                          <button
                            class="btn btn-primary p-1"
                            (click)="
                              fetchRecent(
                                $event,
                                false,
                                selectedFeed.period,
                                selectedFeed.time_zone,
                                selectedFeed.metric,
                                selectedFeed.field
                              )
                            "
                          >
                            Fetch Newer
                          </button>
                          <button
                            class="btn btn-primary p-1"
                            (click)="
                              fetchRecent(
                                $event,
                                true,
                                selectedFeed.period,
                                selectedFeed.time_zone,
                                selectedFeed.metric,
                                selectedFeed.field
                              )
                            "
                          >
                            <i class="fa fa-plus-circle"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <ng-container *ngIf="selectedFeed.variant_entries">
                      <div
                        class="row border-bottom"
                        *ngFor="let entry of selectedFeed.entries | values"
                      >
                        <div class="col-3">
                          {{ entry.time | date : "short" }}
                        </div>
                        <div class="col">{{ entry.variant }}</div>
                        <div class="col">{{ entry.spot_value }}</div>
                        <div class="col">{{ entry.average_value }}</div>
                        <div class="col">{{ entry.maximum_value }}</div>
                        <div class="col">{{ entry.minimum_value }}</div>
                        <div class="col">{{ entry.tally_value }}</div>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="!selectedFeed.variant_entries">
                      <div
                        class="row border-bottom"
                        *ngFor="let entry of selectedFeed.entries | values"
                      >
                        <div class="col-3">
                          {{ entry.time | date : "short" }}
                        </div>
                        <div class="col">
                          {{ entry.spot_value || "Not found" }}
                        </div>
                        <div class="col">{{ entry.average_value }}</div>
                        <div class="col">{{ entry.maximum_value }}</div>
                        <div class="col">{{ entry.minimum_value }}</div>
                        <div class="col">{{ entry.tally_value }}</div>
                      </div>
                    </ng-container>

                    <div class="row mt-2">
                      <div class="col text-center">
                        <new-spinner
                          *ngIf="selectedFeed.fetching"
                          [size]="'sm'"
                        ></new-spinner>
                        <div class="btn-group" *ngIf="!selectedFeed.fetching">
                          <button
                            class="btn btn-primary p-1"
                            (click)="
                              fetch(
                                $event,
                                false,
                                selectedFeed.period,
                                selectedFeed.time_zone,
                                selectedFeed.metric,
                                selectedFeed.field
                              )
                            "
                          >
                            Fetch More|
                            {{
                              selectedFeed.feed_coverage_start | date : "short"
                            }}
                          </button>
                          <button
                            class="btn btn-primary p-1"
                            (click)="
                              fetch(
                                $event,
                                true,
                                selectedFeed.period,
                                selectedFeed.time_zone,
                                selectedFeed.metric,
                                selectedFeed.field
                              )
                            "
                          >
                            <i class="fa fa-plus-circle"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </tab>
                <tab heading="Graph" (selectTab)="onGraphTabSelected()">
                  <div class="row mb-2" *ngIf="entity">
                    <div class="col-12 d-flex flex-wrap align-items-center">
                      <ng-container
                        *ngFor="let source of objectValues(entity.feeds)"
                      >
                        <ng-container
                          *ngTemplateOutlet="
                            graphSource;
                            context: { $implicit: source }
                          "
                        ></ng-container>
                      </ng-container>
                    </div>
                  </div>

                  <div class="col-12 my-3" style="width: 100%;">
                    <div
                      #echartContainer
                      style="width: 100%; height: 580px; min-height: 480px;"
                    ></div>
                  </div>
                </tab>
              </tabset>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <!--                                                        -->
    <!--                    Pop-Up Menu                         -->
    <!--                                                        -->
    <ng-template #chartModal>
      <modal-widget
        *ngIf="currentModal"
        (widgetEvent)="eventHandler($event, 'pop-up', chartModal)"
        [entity]="currentModal"
        [layout]="'shadowbox'"
        [options]="{}"
      ></modal-widget>
    </ng-template>
  